<template>
  <div>
    <div class="style-browser">
      <div id="style-col" class="browse-col">
        <div class="h2">{{ $nippets.browseByStyle}}</div>
        <div class="two-col">
          <ix-router-link v-for="gal in styles" :key="gal.gallery_id" :to="gal.url" v-html="gal.name"></ix-router-link>
        </div>
      </div>
      <div id="category-col" class="browse-col">
        <div class="h2">{{ $nippets.browseByCategory}}</div>
        <div class="one-col">
          <ix-router-link v-for="gal in categories" :key="gal.gallery_id" :to="gal.url" v-html="gal.name"></ix-router-link>
        </div>
      </div>
      <div id="medium-col" class="browse-col">
        <div v-show="mediums.length > 0">
          <div class="h2">{{ $nippets.browseByMedium}}</div>
          <div class="one-col">
            <ix-router-link v-for="gal in mediums" :key="gal.gallery_id" :to="gal.url" v-html="gal.name"></ix-router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StyleFetcher from '@/mixins/StyleFetcher.js'
export default {
  mixins: [StyleFetcher]
}
</script>


